var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptionsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 5.3998C8.0059 5.3998 7.20001 4.59392 7.20001 3.5998C7.20001 2.60569 8.0059 1.7998 9.00001 1.7998C9.99412 1.7998 10.8 2.60569 10.8 3.5998C10.8 4.59392 9.99412 5.3998 9.00001 5.3998Z",
    fill: "#C6C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 10.7998C8.0059 10.7998 7.20001 9.99392 7.20001 8.9998C7.20001 8.00569 8.0059 7.1998 9.00001 7.1998C9.99412 7.1998 10.8 8.00569 10.8 8.9998C10.8 9.99392 9.99412 10.7998 9.00001 10.7998Z",
    fill: "#C6C6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 16.1998C8.0059 16.1998 7.20001 15.3939 7.20001 14.3998C7.20001 13.4057 8.0059 12.5998 9.00001 12.5998C9.99412 12.5998 10.8 13.4057 10.8 14.3998C10.8 15.3939 9.99412 16.1998 9.00001 16.1998Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsIcon);
export default __webpack_public_path__ + "static/media/options-icon.14ac2604153d4c13e4874c4a216c2f1e.svg";
export { ForwardRef as ReactComponent };